import logoPath from "@assets/Asset 1_1750308719655.png";

interface SaaSGamaLogoProps {
  size?: "sm" | "md" | "lg";
  variant?: "light" | "dark";
  showText?: boolean;
  className?: string;
}

export function SaaSGamaLogo({ 
  size = "md", 
  variant = "light", 
  showText = false, 
  className = "" 
}: SaaSGamaLogoProps) {
  const sizeClasses = {
    sm: "h-6",
    md: "h-10", 
    lg: "h-12"
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={logoPath}
        alt="SaaSGama"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
}